<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from '@/Shared/Navigation/TabNavigator';
import TwitterIcon from '@/Shared/SVG/TwitterIcon';
import LinkedinIcon from '@/Shared/SVG/LinkedinIcon';
import SmsIcon from '@/Shared/SVG/SmsIcon';

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'About', href: route('company.about'), current: false },
    { name: 'Team', href: route('company.team'), current: true },
    { name: 'Partners', href: route('company.partners'), current: false },
    { name: 'Legal', href: route('company.legal'), current: false },
];
</script>

<template>
    <div class="relative w-full">
        <TabNavigator :tabs="tabNavigation" />
        <h2
            class="mt-12 px-2 text-center text-3xl font-bold text-white sm:mt-16"
        >
            Team
        </h2>
        <div class="relative mt-12 mb-40 sm:mt-16">
            <div class="flex grid-cols-3 flex-col gap-7 lg:mx-8 lg:grid">
                <div
                    class="hidden flex-col justify-between rounded-2xl bg-wgn-blue-1 px-5 py-4 lg:flex"
                    v-for="item in data"
                >
                    <div class="mb-4">
                        <div class="aspect-w-1 aspect-h-1">
                            <img
                                class="rounded-lg object-cover shadow-lg"
                                :src="item.image"
                                :alt="item.name"
                            />
                        </div>
                        <div class="mt-4 flex items-center justify-between">
                            <div class="flex flex-col justify-start">
                                <span class="text-2xl text-white">{{
                                    item.name
                                }}</span>
                                <span
                                    class="text-white text-opacity-60"
                                    v-if="item.title !== null"
                                    >{{ item.title }}</span
                                >
                            </div>
                            <div class="flex items-center space-x-6">
                                <a
                                    :href="item.twitter"
                                    target="_blank"
                                    v-if="item.twitter !== null"
                                >
                                    <TwitterIcon
                                        class="h-4 w-4 text-white opacity-40"
                                    ></TwitterIcon>
                                </a>
                                <a
                                    :href="item.linkedin"
                                    target="_blank"
                                    v-if="item.linkedin !== null"
                                >
                                    <LinkedinIcon
                                        class="h-5 w-5"
                                    ></LinkedinIcon>
                                </a>
                            </div>
                        </div>
                        <div class="mt-4">
                            <p class="text-white text-opacity-60">
                                {{ item.brief }}
                            </p>
                        </div>
                    </div>
                    <div class="border-t border-white border-opacity-10 pt-4">
                        <Link
                            :href="route('contact')"
                            class="flex items-center justify-start space-x-3.5"
                        >
                            <SmsIcon class="h-5 w-5 text-white"></SmsIcon>
                            <span class="text-white"
                                >Contact {{ item.name }}</span
                            >
                        </Link>
                    </div>
                </div>

                <!--  Mobile -->
                <div
                    class="flex flex-col space-y-4 rounded-2xl bg-wgn-blue-1 px-5 py-4 lg:hidden"
                    v-for="item in data"
                >
                    <div class="flex items-center justify-between">
                        <div
                            class="flex items-center justify-between space-x-4"
                        >
                            <div
                                class="flex h-[75px] w-[75ox] justify-center rounded-lg border border-wgn-gray-3"
                            >
                                <img
                                    class="w-full rounded-lg object-scale-down"
                                    :src="item.image"
                                    :alt="item.name"
                                />
                            </div>
                            <div class="flex flex-col space-y-1">
                                <span class="text-lg text-white">{{
                                    item.name
                                }}</span>
                                <span
                                    class="text-white text-opacity-60"
                                    v-if="item.title !== null"
                                    >{{ item.title }}</span
                                >
                            </div>
                        </div>
                        <div class="flex items-center space-x-6">
                            <a
                                :href="item.twitter"
                                target="_blank"
                                v-if="item.twitter !== null"
                            >
                                <TwitterIcon
                                    class="h-4 w-4 text-white opacity-40"
                                ></TwitterIcon>
                            </a>
                            <a
                                :href="item.linkedin"
                                target="_blank"
                                v-if="item.linkedin !== null"
                            >
                                <LinkedinIcon class="h-5 w-5"></LinkedinIcon>
                            </a>
                        </div>
                    </div>
                    <div class="">
                        <p class="text-white text-opacity-60">
                            {{ item.brief }}
                        </p>
                    </div>
                    <div class="border-t border-white border-opacity-10 pt-4">
                        <Link
                            :href="route('contact')"
                            class="flex items-center justify-start space-x-3.5"
                        >
                            <SmsIcon class="h-5 w-5 text-white"></SmsIcon>
                            <span class="text-white"
                                >Contact {{ item.name }}</span
                            >
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
